<template>
  <OnboardingFeatureView>
    <p>
      Add new players to your crew with a QR code or an invite link
    </p>
    <InviteCard
      v-bind="{joinUrl}"
      excludeInstructions
    />
  </OnboardingFeatureView>
</template>

<script setup lang="ts">
import InviteCard from "@/components/InviteCard.vue";
import { RouteName } from "@/lib/router/routes.ts";
import getAppUrl from "@/lib/utils/http/getAppUrl";
import { computed } from "vue";
import { useRouter } from "vue-router";
import OnboardingFeatureView from "./OnboardingFeatureView.vue";

const router = useRouter();

const joinUrl = computed(() => {
  return getAppUrl(router.resolve({ name: RouteName.onboardingInvites }).path);
});
</script>
